import { makeStyles } from "@material-ui/core";
import theme from "../../../themes";

export const useProgramStyles = makeStyles(() => ({
  mainContainer: {
    border: "1px solid #e8eaf0",
    overflow: "hidden",
    "& .MuiPaper-elevation1": {
      padding: "unset",
    },
  },
  degreeName: {
    fontSize: 16,
    fontWeight: "bold",
    color: " #535358",
    paddingRight: 8,
  },
  degreeWord: {
    fontSize: 14,
    fontWeight: "bold",
    color: " #828190",
    paddingRight: 16,
  },
  majorsCount: {
    fontSize: 14,
    color: "#828190",
  },
  content: {
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      borderBottom: "1px solid #dfdcd6",
    },
  },
  labeledContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    "& > :first-child": {
      fontSize: 14,
      fontWeight: "bold",
      color: " #828190",
    },
    "& > :last-child": {
      fontSize: 14,
      color: " #535358",
    },
  },
  gridContainer: {
    maxWidth: 800,
  },
  link: {
    fontWeight: "bold",
    color: "#2f80ed",
    "&:hover": {
      color: "#1368d8",
      cursor: "pointer",
    },
  },
  disabled: {
    opacity: 0.3,
    background: "#f8f9fb",
    pointerEvents: "none",
  },
}));
